<template>
  <div class="contact">
    <div class="contact_content">
        <div class="content_top">
          <h1 v-if="chOrEn!='0'" style="font-weight: bold;">联系我们</h1>
          <!-- <h4 v-if="chOrEn!='0'">生活因为您的来电而更美好</h4> -->
          <h1 v-if="chOrEn=='0'" style="font-weight: bold;">Contact Us</h1>
          <!-- <h1 v-if="chOrEn!=='0'" style="font-weight: bold;font-size:20px;color:#C0CCDA;line-height:30px">Contact Us</h1>
          <h1 v-if="chOrEn=='0'" style="font-weight: bold;font-size:20px;color:#C0CCDA;line-height:30px">联系我们</h1> -->
          <!-- <h4 v-if="chOrEn!='0'">生活因为您的来电而更美好</h4> -->
          <!-- <h4 v-if="chOrEn=='0'">Life is better because of your call</h4> -->
        </div>
        <div class="bei">
            <div class=" container">
                <div class="ss cent" ref="shang">
                    <div style="width:50%;" class="bie" :style="{height: tu}">
                        <!-- <img src="../assets/img/cu.png" width=100%  height=100%/> -->
                    </div>
                    <div class="content_bottom" style="width:50%;background:#FFFFFF">
                        <ul class="bottom_content">
                            <li class="content_item">
                            <h3   style="font-weight:600;margin-bottom:12px;color:#24367D"><div style="width:206px">
                  <img src="../assets/img/weizhi.png" width=100%  />
                </div></h3>
                            <h3 v-if="chOrEn!='0'"  style="font-weight:600;margin-bottom:12px;color:#24367D">联盟秘书处：</h3>
                            <h3 v-else  style="font-weight:600">Union Secretariat:</h3>
                            <h3 v-if="chOrEn!='0'" class="leftTop" style="font-size:16px"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/dian.png" style="color:#FFFFFF" alt /></span>联系电话：{{list.telphone}}</h3>
                            <h3 v-else class="leftTop" style="font-size:16px"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/dian.png" style="color:#FFFFFF" alt /></span>Contact Number：{{list.telphone}}</h3>
                            </li>
                            <li class="content_item" style="font-size:16px">
                            <h3 v-if="chOrEn!='0'" class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/fan.png" style="color:#FFFFFF" alt /></span>邮箱：{{list.email}}</h3>
                            <h3 v-else class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/fan.png" style="color:#FFFFFF" alt /></span>Email：{{list.email}}</h3>
                            </li>
                            <li class="content_item">
                            <h3 v-if="chOrEn!='0'" class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/ding.png" style="color:#FFFFFF" alt /></span>地址：{{list.address}}</h3>
                            <h3 v-else class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/ding.png" style="color:#FFFFFF" alt /></span>Address：{{list.address}}</h3>
                            <h3 v-if="chOrEn!='0'" style="font-weight:600;margin-top:12px;color:#24367D">联盟瑞士总部：</h3>
                            <!-- <h3 v-if="chOrEn!='0'" style="font-weight:600;margin-bottom:12px;margin-top:48px;color:#24367D">联盟瑞士总部：</h3> -->
                            <h3 v-else style="font-weight:600;margin-top:12px">Union Headquarters in Switzerland：</h3>
                            </li>
                            <li class="content_item" style="font-size:16px">
                            <h3 v-if="chOrEn!='0'" class="leftTop"  style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/fan.png" style="color:#FFFFFF" alt /></span>邮箱：gka@art-st-urban.com</h3>
                            <h3 v-else class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/fan.png" style="color:#FFFFFF" alt /></span>Email：gka@art-st-urban.com</h3>
                            </li>
                            <li class="content_item">
                            <!-- <h3>art-st-urban:</h3> -->
                            <h3 v-if="chOrEn!='0'" class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/ding.png" style="color:#FFFFFF" alt /></span>地址：CH-4915 St. Urban • Lucerne • Weierweg 3 • Switzerland</h3>
                            <h3 v-else class="leftTop" style="font-size:16px"><span style="margin-right:10px"><img src="../assets/img/ding.png" style="color:#FFFFFF" alt /></span>Address：CH-4915 St. Urban • Lucerne • Weierweg 3 • Switzerland</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>

  import {contentget} from '../api/api'
export default {
  name: "contact",

  data() {
    return {
        list:{},
        tu:'',
        chOrEn:sessionStorage.getItem('chOrEn'),
    };
  },
  created(){
    let navigationId = {
      "navigationId":"1"
    }
    contentget({...navigationId}).then(res=>{
      console.log(res.data.data.email4Apply,res)
      this.list=res.data.data
    })
  },
  mounted() {
    this.initMap();
    this.tu=this.$refs.shang.offsetHeight+"px"
    window.addEventListener('scroll',this.handleScrollx,true)
  },
  methods: {
    handleScrollx() {
      this.tu=this.$refs.shang.offsetHeight+"px"
      // debugger
      // debugger
    },
    initMap() {
      // 百度地图API功能
      var map = new BMap.Map("allmap");
      var poi = new BMap.Point(125.340278, 43.828262);
      map.centerAndZoom(poi, 16);
      map.enableScrollWheelZoom();

      var content =
        '<div style="margin:0;line-height:20px;padding:2px;">' +
        '<img src="https://bkimg.cdn.bcebos.com/pic/3bf33a87e950352ac65c990fee0aecf2b21193131d28?x-bce-process=image/watermark,image_d2F0ZXIvYmFpa2UxMTY=,g_7,xp_5,yp_5" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
        "地址：长春世界雕塑园<br/>电话：(0431)85379019<br/>简介：长春世界雕塑园是4A级国家景区,是第一批国家重点公园" +
        "</div>";

      //创建检索信息窗口对象
      var searchInfoWindow = null;
      searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
        title: "长春世界雕塑园", //标题
        width: 290, //宽度
        height: 105, //高度
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [
          BMAPLIB_TAB_SEARCH, //周边检索
          BMAPLIB_TAB_TO_HERE, //到这里去
          BMAPLIB_TAB_FROM_HERE, //从这里出发
        ],
      });
      var marker = new BMap.Marker(poi); //创建marker对象
      marker.enableDragging(); //marker可拖拽
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
      marker.addEventListener("click", function (e) {
        searchInfoWindow.open(marker);
      });
      map.addOverlay(marker); //在地图中添加marker
      //样式1
      var searchInfoWindow1 = new BMapLib.SearchInfoWindow(map, "信息框1内容", {
        title: "信息框1", //标题
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [
          BMAPLIB_TAB_FROM_HERE, //从这里出发
          BMAPLIB_TAB_SEARCH, //周边检索
        ],
      });
      function openInfoWindow1() {
        searchInfoWindow1.open(new BMap.Point(125.340278, 43.828262));
      }
      //样式2
      var searchInfoWindow2 = new BMapLib.SearchInfoWindow(map, "信息框2内容", {
        title: "信息框2", //标题
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [
          BMAPLIB_TAB_SEARCH, //周边检索
        ],
      });
      function openInfoWindow2() {
        searchInfoWindow2.open(new BMap.Point(125.340278, 43.828262));
      }
      //样式3
      var searchInfoWindow3 = new BMapLib.SearchInfoWindow(map, "信息框3内容", {
        title: "信息框3", //标题
        width: 290, //宽度
        height: 40, //高度
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [],
      });
      function openInfoWindow3() {
        searchInfoWindow3.open(new BMap.Point(125.340278, 43.828262));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cent{
  display: flex;
  justify-content: center;
  align-items: center;
}
.left{
  display: flex;
  justify-content:  flex-start;
  align-items: center;
}
.leftTop{
  display: flex;
  justify-content:  flex-start;
  align-items: flex-start;
}
.content_top {
    text-align: center;
    padding: 80px 0 54px 0;
    h1 {
    font-size: 40px;
    line-height: 60px;
    }
    h4 {
    font-size: 24px;
    line-height: 38px;
    }
}
.bie{
  background: url("../assets/img/5.jpg") no-repeat;
    // background-position: bottom;
    background-size: 100% 100%;
}
.bei{
    background: url("../assets/img/foot.png") no-repeat;
    // background-position: bottom;
    background-size: 100% 100%;
}
.contact_content {
  width: 100%;
//   height:1130px;
//   background: url("../assets/img/foot.png") no-repeat;
  .container {
    padding: 0 0 80px 0;
    // height: 1130px;
    color: #010101;
    .ss{
        background:#FFFFFF;

    }
    .content_bottom {
        background:#FFFFFF;
    //   width: 100%;
    //   height: 610px;
    //   border-radius: 10px;
    //   background: url("../assets/img/contact_03.png") no-repeat;
      background-size: 100% 100%;
    //   padding-top: 70px;
    //   padding-bottom: 70px;
    //   padding-left: 630px;
      .bottom_content {
        // width: 412px;
        // height: 468px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 15px;
        // padding-top: 36px;
        padding-left: 40px;
        padding-right: 25px;
        .content_item {
          cursor: pointer;
          h3 {
            font-size: 20px;
            line-height: 32px;
            // padding-top:16px;
            li{
                padding-top:28px
            }
          }
          margin-bottom: 5px;
        }
      }
    }
  }
}
dl,
dt,
dd,
ul,
li {
  margin: 0;
  padding: px0;
  list-style: none;
}
dt {
  font-size: 14px;
  font-family: "微软雅黑";
  font-weight: bold;
  border-bottom: 1px dotted #000;
  padding: 5px 0 5px 5px;
  margin: 5px 0;
}
dd {
  padding: 5px 0 0 5px;
}
li {
  line-height: 28px;
}
/deep/ .BMapLib_SearchInfoWindow .BMapLib_bubble_bottom {
  height: 18px !important;
}
</style>